/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivExceptionViewmodelGen,
  MrfiktivPageViewModelGen,
  MrfiktivRealtimeSessionControllerFindAllParamsGen,
  MrfiktivRealtimeSessionViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class CallSessionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerFindAll
   * @summary Get all realtime sessions for a partner
   * @request GET:/partner/{partnerId}/call
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRealtimeSessionViewModelGen)[] })`
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerFindAll = (
    { partnerId, ...query }: MrfiktivRealtimeSessionControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivRealtimeSessionViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/partner/${partnerId}/call`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Call Session Service
   * @name RealtimeSessionControllerFindOne
   * @summary Get a realtime session by ID
   * @request GET:/partner/{partnerId}/call/{sessionId}
   * @secure
   * @response `200` `MrfiktivRealtimeSessionViewModelGen` The realtime session with call tracking data
   * @response `400` `MrfiktivExceptionViewmodelGen` Bad Request
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `404` `MrfiktivExceptionViewmodelGen` NotFound.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  realtimeSessionControllerFindOne = (partnerId: string, sessionId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRealtimeSessionViewModelGen, MrfiktivExceptionViewmodelGen>({
      path: `/partner/${partnerId}/call/${sessionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
